module.exports = "<div class=\"column-resizer__handler\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Section/ColumnResizer/column-resizer.html
// module id = 1183
// module chunks = 0